import { faGithubSquare } from "@fortawesome/free-brands-svg-icons";
import {
  faDesktop,
  faExternalLinkSquareAlt,
  faHome,
  faPlusSquare,
  faServer,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {
  ButtonGroup,
  Carousel,
  Col,
  Container,
  Row,
  Button,
} from "react-bootstrap";
import { useParams } from "react-router";
import { NavLink } from "react-router-dom";
import Zoom from "react-reveal/Zoom";

const ProjectDetails = () => {
  const title = {
    fontFamily: "'Satisfy', cursive",
    color: "#033d44",
  };
  const color = {
    color: "#033d44",
    fontWeight: "bold",
  };
  const { project } = useParams();
  const [projects, setProjects] = useState([]);
  const [info, setInfo] = useState({});
  useEffect(() => {
    fetch("https://debasree97.github.io/data-portfolio/data.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, [project]);
  useEffect(() => {
    const singleProject = projects.find((pro) => pro?.name === project);
    setInfo(singleProject);
  }, [projects, project]);

  return (
    <Container className="mb-5">
      <h1 className="display-4 fw-bold ps-2 my-5 text-center" style={title}>
        About {info?.name}
      </h1>
      <Row>
        <Col className="border border-dark" style={{ height: "100%" }} xs={12}>
          <Carousel variant="dark">
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={info?.img1}
                alt="First slide"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={info?.img2}
                alt="Second slide"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={info?.img3}
                alt="Third slide"
              />
            </Carousel.Item>
          </Carousel>
        </Col>
        <Zoom cascade>
          <Col xs={12} className="mt-5 ps-3">
            <p className="fs-5">
              <span style={color}>Technology:</span> {info?.technology}
            </p>
            <p className="fs-5">
              <span style={color}>Description:</span> {info?.description}
            </p>
            <p className="fs-5">
              <span style={color}>OverView:</span>
            </p>
            <Container>
              <p>
                <FontAwesomeIcon
                  style={{
                    color: "#033d44",
                    fontWeight: "bold",
                    marginRight: "10px",
                  }}
                  icon={faPlusSquare}
                />
                {info?.feature1}
              </p>
              <p>
                <FontAwesomeIcon
                  style={{
                    color: "#033d44",
                    fontWeight: "bold",
                    marginRight: "10px",
                  }}
                  icon={faPlusSquare}
                />
                {info?.feature2}
              </p>
              <p>
                <FontAwesomeIcon
                  style={{
                    color: "#033d44",
                    fontWeight: "bold",
                    marginRight: "10px",
                  }}
                  icon={faPlusSquare}
                />
                {info?.feature3}
              </p>
              <p>
                <FontAwesomeIcon
                  style={{
                    color: "#033d44",
                    fontWeight: "bold",
                    marginRight: "10px",
                  }}
                  icon={faPlusSquare}
                />
                {info?.feature4}
              </p>
              <p>
                <FontAwesomeIcon
                  style={{
                    color: "#033d44",
                    fontWeight: "bold",
                    marginRight: "10px",
                  }}
                  icon={faPlusSquare}
                />
                {info?.feature5}
              </p>
            </Container>
            <ButtonGroup>
              <Button variant="outline-dark">
                <FontAwesomeIcon
                  style={{
                    color: "#033d44",
                    fontWeight: "bold",
                    marginRight: "2px",
                  }}
                  icon={faExternalLinkSquareAlt}
                />{" "}
                <a
                  className="custom-btn"
                  href={info?.liveWebsite}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="d-none d-sm-block">Live Website</span>
                </a>
              </Button>
              <Button variant="outline-dark">
                <a
                  className="custom-btn"
                  href={info?.client}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon
                    style={{
                      color: "#033d44",
                      fontWeight: "bold",
                      marginRight: "2px",
                    }}
                    icon={faDesktop}
                  />{" "}
                  <span className="d-none d-sm-block">Client Code</span>
                </a>
              </Button>
              {info?.server && (
                <Button variant="outline-dark">
                  <a
                    className="custom-btn"
                    href={info?.server}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      style={{
                        color: "#033d44",
                        fontWeight: "bold",
                        marginRight: "2px",
                      }}
                      icon={faServer}
                    />{" "}
                    <span className="d-none d-sm-block">Server Code</span>
                  </a>
                </Button>
              )}
              <Button variant="outline-dark">
                <NavLink className="custom-btn" to="/home">
                  <FontAwesomeIcon
                    style={{
                      color: "#033d44",
                      fontWeight: "bold",
                      marginRight: "2px",
                    }}
                    icon={faHome}
                  />{" "}
                  <span className="d-none d-sm-block">Home</span>
                </NavLink>
              </Button>
            </ButtonGroup>
          </Col>
        </Zoom>
      </Row>
    </Container>
  );
};

export default ProjectDetails;
